module.exports = __webpack_public_path__ + "img/examples-ru-1.c1eaf4ba.jpg";